/* unplugin-vue-components disabled */import script from "./ShareButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareButton.vue?vue&type=script&setup=true&lang=js"

import "./ShareButton.vue?vue&type=style&index=0&id=32c51901&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c51901"]])

export default __exports__